// import { useEffect, useState } from "react";
// import { BASE_URL } from "./BaseUrl";
// import projectlogo from "../assets/projectlogo.png";   // ✅ fallback logo
// import websitelogo from "../assets/websitelogo.png";
// import { useTranslation } from "react-i18next";

// export const useCompanyProfile = (token) => {
//   const [logoBase64, setLogoBase64] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { i18n } = useTranslation();
//   const currentLang = i18n.language || "en"; // en | es

//   // Convert blob to base64
//   const blobToBase64 = (blob) => {
//     return new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.readAsDataURL(blob);
//     });
//   };

//   // Fetch image URL → return blob or null
//   const fetchImageBlob = async (url) => {
//     try {
//       const res = await fetch(url);

//       if (!res.ok) {
//         console.warn("❌ Logo URL invalid:", url);
//         return null;
//       }

//       return await res.blob();
//     } catch (err) {
//       console.warn("❌ Error fetching company logo:", err);
//       return null;
//     }
//   };

//   // Fetch fallback project logo → base64
//   const loadFallbackLogo = async () => {
//     const blob = await fetch(projectlogo).then((r) => r.blob());
//     return await blobToBase64(blob);
//   };

//   useEffect(() => {
//     console.log("useCompanyProfile HOOK MOUNTED");

//     const loadProfile = async () => {
//       try {
//         const res = await fetch(`${BASE_URL}/company-admins/profile`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const json = await res.json();
//         const logoUrl = json?.data?.company?.logo;

//         console.log("RAW LOGO URL:", logoUrl);

//         let base64Logo = null;

//         if (logoUrl) {
//           const logoBlob = await fetchImageBlob(logoUrl);

//           if (logoBlob) {
//             base64Logo = await blobToBase64(logoBlob);
//             console.log("FINAL BASE64 LOGO:", base64Logo?.substring(0, 50));
//           } else {
//             console.log("⚠️ Using fallback because company logo is missing or broken");
//             base64Logo = await loadFallbackLogo();
//           }
//         } else {
//           console.log("⚠️ No logo URL in API → using fallback project logo");
//           base64Logo = await loadFallbackLogo();
//         }

//         setLogoBase64(base64Logo);

//       } catch (error) {
//         console.error("PROFILE ERROR → using fallback:", error);
//         const fallback = await loadFallbackLogo();
//         setLogoBase64(fallback);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadProfile();
//   }, [token]);

//   return { logoBase64, loading };
// };


import { useEffect, useState } from "react";
import { BASE_URL } from "./BaseUrl";
import projectlogo from "../assets/projectlogo.png";
import websitelogo from "../assets/websitelogo.png";
import { useTranslation } from "react-i18next";

export const useCompanyProfile = (token) => {
  const { i18n } = useTranslation();
  const [logoBase64, setLogoBase64] = useState(null);
  const [loading, setLoading] = useState(true);

  const currentLang = i18n.language || "en"; // en | es

  // Convert blob to base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  // Fetch image URL → return blob or null
  const fetchImageBlob = async (url) => {
    try {
      const res = await fetch(url);

      if (!res.ok) {
        console.warn("❌ Invalid company logo:", url);
        return null;
      }

      return await res.blob();
    } catch (err) {
      console.warn("❌ Error fetching company logo:", err);
      return null;
    }
  };

  // Select fallback based on language
  const selectFallbackLogo = () => {
    return currentLang === "es" ? websitelogo : projectlogo;
  };

  // Load fallback as base64
  const loadFallbackLogo = async () => {
    const selectedLogo = selectFallbackLogo();
    const blob = await fetch(selectedLogo).then((r) => r.blob());
    return await blobToBase64(blob);
  };

  useEffect(() => {
    console.log("useCompanyProfile HOOK MOUNTED");

    const loadProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/company-admins/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const json = await res.json();
        const logoUrl = json?.data?.company?.logo;

        console.log("RAW LOGO URL:", logoUrl);

        let base64Logo = null;

        // 1️⃣ Try real company logo
        if (logoUrl) {
          const logoBlob = await fetchImageBlob(logoUrl);

          if (logoBlob) {
            base64Logo = await blobToBase64(logoBlob);
            console.log("✔ Company Logo Loaded:", base64Logo?.substring(0, 40));
          } else {
            console.log("⚠️ Company logo broken → using language-based fallback");
            base64Logo = await loadFallbackLogo();
          }
        }

        // 2️⃣ If API has no logo at all → use fallback
        if (!base64Logo) {
          console.log("⚠️ No logo in API → using language-based fallback");
          base64Logo = await loadFallbackLogo();
        }

        setLogoBase64(base64Logo);

      } catch (error) {
        console.error("PROFILE ERROR → using fallback:", error);
        const fallback = await loadFallbackLogo();
        setLogoBase64(fallback);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [token, currentLang]); // re-run when language changes

  return { logoBase64, loading };
};
